import React, { useEffect } from "react";
import "./index.scss";
import ContactFormForm from "../../modules/ContactFormSection";
import { Text, Media, Logo, Box } from "@mbank-design/design-system/components";
import { FontColor } from "@mbank-design/design-system/enums";
import { FontSize, FontWeight, LineHeight } from "@mbank-design/design-system/design-tokens/general/typography";
import { isWebpSupported as webpSupported } from "../../../scripts/commons/support-webp";
import { Mauto40StripeMassDarkTheme } from "@mbank-design/design-system/logos";

import backgroundImageWeb from "./img/cash_web.jpg";
import backgroundImageMobile from "./img/cash_web.jpg";
import backgroundImageWebWebP from "./img/cash_web.webp";
import backgroundImageMobileWebP from "./img/cash_web.webp";
import { clearCampaignData, setCampaignData } from "../../common/campaign-data-setter";
import { Helmet } from "react-helmet";
import { useMobileOnlyMedia } from "@mbank-design/design-system/components/Media/useMobileOnlyMedia";

const LandingPageCash = (props) => {
  const isWebpSupported = webpSupported();
  const isMobile = useMobileOnlyMedia();

  const downloadSiteRules = () => {
    props.downloadSiteRules().then((res) => {
      props.clickAnchorWithRegulations(res);
    });
  };

  useEffect(() => {
    clearCampaignData();
    setCampaignData();
    // const globalScript = document.querySelector('script[src="https://trafficscanner.pl/ws2/script/3729/koniec.js"]');
    // if (globalScript) {
    //   globalScript.remove();
    // }
    // const script = document.createElement("script");
    // script.src = "https://trafficscanner.pl/ws2/script/3605/koniec.js";
    // script.type = "text/javascript";
    // document.body.appendChild(script);
    // return () => {
    //   document.body.removeChild(script);
    //   document.body.appendChild(globalScript);
    // };
  }, []);

  return (
    <div className="landingPageCash">
      <div className="landingPageCash__top">
        <div className="landingPageCash__left">
          <Helmet>
            <link rel="canonical" href={window.location.href} />
          </Helmet>
          <Box display={"flex"} flexDirection={["column","row"]} position={"absolute"} margin={"auto"} width={"100%"} gap={32} maxWidth={1600} height={"100%"} paddingX={32} paddingY={16} alignItems={"center"}>
            <Box
              display={"flex"}
              alignItems={"center"}
              flexDirection={"column"}
              justifyContent={"center"}
            >
              <Box position={["relative","absolute"]} top={[0,32]} left={[0,32]} zIndex={2}>
                <Logo logoComponent={Mauto40StripeMassDarkTheme} height={!isMobile ? 71 : 35} />
              </Box>
              <Box zIndex={2}>
                <Text
                  as={"h1"}
                  styledAs={!isMobile ? "h1_large" : "h3"}
                  className={"landingPageCash__header"}
                  fontWeight={"bold"}
                  color={FontColor.LIGHT}
                  align={["center","left"]}
                >
                  masz już wybrane auto, ale szukasz finansowania?
                </Text>
                <Text
                  as={"h2"}
                  styledAs={!isMobile ? "h1" : "h5"}
                  className={"landingPageCash__subtext"}
                  color={FontColor.LIGHT}
                  align={["center","left"]}
                >
                  Nasz doradca przygotuje dla Ciebie atrakcyjną ofertę!
                </Text>
              </Box>
            </Box>
            <div className="landingPageCash__contact-form-section">
              <ContactFormForm isSpecialLandingPage lpCash />
            </div>
          </Box>
          <Media.DesktopOnly>
            <img
              src={isWebpSupported ? backgroundImageWebWebP : backgroundImageWeb}
              alt="Cash car"
              className="landingPageCash__background-image"
            />
          </Media.DesktopOnly>
          <Media.MobileOnly>
            <img
              src={isWebpSupported ? backgroundImageMobileWebP : backgroundImageMobile}
              alt="Cash car"
              className="landingPageCash__background-image"
            />
          </Media.MobileOnly>
        </div>
      </div>
    </div>
  );
};

export default LandingPageCash;
